import { defineComponent as _defineComponent } from 'vue'
import { OIcon } from '@oruga-ui/oruga'


export default /*#__PURE__*/_defineComponent({
  __name: 'NeoIcon',
  props: {
    size: null,
    icon: null,
    pack: null,
    customSize: null,
    variant: null
  },
  setup(__props: any) {



return { __sfc: true,OIcon }
}

})